import mastercardBlack from '../images/mastercard-black.png'

export default {
  bradesco: {
    prime: {
      black: mastercardBlack,
    },
  },
  itau: {
    normal: {
      black: mastercardBlack,
    },
  },
  bb: {
    ourocard: {
      black: mastercardBlack,
    },
  },
}



// WEBPACK FOOTER //
// ./components/ModelLogo/helpers/modelLogos.js